// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__FjjSi","disabled":"styles_disabled__FZBt8","black":"styles_black__NcgSz"};